
import DetailCaption from '@/components/tupian/detail/detail-caption';
import DetailBreadCrumbs from '@/components/tupian/detail/detail-bread-crumbs'

let ComponentMixin = {

  components:{
    DetailCaption,
    DetailBreadCrumbs
  }
}

export default ComponentMixin;
